// extracted by mini-css-extract-plugin
export default {"title":"MonitoringDetailsModal_title__030aQ","description":"MonitoringDetailsModal_description__+1WTt"};